import { render, staticRenderFns } from "./Zoom.vue?vue&type=template&id=631cb900&scoped=true&"
import script from "./Zoom.vue?vue&type=script&lang=ts&"
export * from "./Zoom.vue?vue&type=script&lang=ts&"
import style0 from "./Zoom.vue?vue&type=style&index=0&id=631cb900&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cb900",
  null
  
)

export default component.exports